import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getCustomer } from "./customerApi";

export interface ICustomerState {
  customer: any;
  addressLocation: any[];
  identityCardTypes: any;
  disabledFields: {
    name: boolean;
    surname: boolean;
    commercialTitle: boolean;
    alias: boolean;
    isEInvoiceUser: boolean;
    dateOfBirth: boolean;
  };
}

const initialState: ICustomerState = {
  customer: "",
  addressLocation: [],
  identityCardTypes: [],
  disabledFields: {
    name: false,
    surname: false,
    commercialTitle: false,
    alias: false,
    isEInvoiceUser: true,
    dateOfBirth: false,
  },
};

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setCustomer: (state, action: PayloadAction<any>) => {
      state.customer = action.payload;
    },
    setAddressLocation: (state, action: PayloadAction<any>) => {
      state.addressLocation = action.payload;
    },
    setDisabledFields: (state, action: PayloadAction<any>) => {
      state.disabledFields = action.payload;
    },
    setIdentityCardTypes: (state, action: PayloadAction<any>) => {
      state.identityCardTypes = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(getCustomer.matchFulfilled, (state, action) => {
      state.customer = action.payload.data;
    });
  },
});

export const {
  setCustomer,
  setAddressLocation,
  setDisabledFields,
  setIdentityCardTypes,
} = customerSlice.actions;

export const selectCustomer = (state: any) => state.customer.customer;

export const selectCustomerAddressLocation = (state: any) =>
  state.customer.addressLocation;

export const selectCustomerDisabledFields = (state: any) =>
  state.customer.disabledFields;

export const selectIdentityCardTypes = (state: any) =>
  state.customer.identityCardTypes;

export default customerSlice.reducer;
